






















import Vue from "vue";
import Facet from "@/components/Facet.vue";
import TagListFacet from "@/components/TagListFacet.vue";
import { Messages } from "@/constants/messages";
import { PayloadFacets } from "@/store/app/types_app";
import { mapGetters } from "vuex";
import DestoreService from "@/services/destore_service";
import { ROUTES } from "@/constants/routes";
export default Vue.extend({
  name: "Search",
  components: { TagListFacet, Facet },
  data(): {
    search: string;
    debounce: number;
    categoriesSelected: string[];
    mess: any;
  } {
    return {
      search: "",
      debounce: 0,
      categoriesSelected: [],
      mess: Messages,
    };
  },
  mounted() {
    this.updateSearchAndRouter();
  },
  computed: {
    ...mapGetters(["getFacetsSelected", "getApps"]),
    getStyleWhenApps() {
      if (this.getApps.length !== 0) {
        return {
          padding: "1% 20% 1% 20%",
          display: "grid",
          "grid-template-columns": "80% 20%",
          "grid-template-rows": "1fr",
          gap: "10px 0",
        };
      } else {
        return {
          padding: "1% 20% 0.5% 20%",
        };
      }
    },
  },
  methods: {
    debounceSearch(): void {
      clearTimeout(this.debounce);
      this.debounce = setTimeout(() => {
        if (this.search) {
          this.$store.dispatch("changeShowMainComponent", {
            showHome: false,
            showRes: true,
          });
          this.$router.push({
            path: ROUTES.SEARCH.path,
            query: DestoreService.paramsRoute(
              this.search,
              this.getFacetsSelected
            ),
          });
        } else {
          this.$router.push({ path: ROUTES.HOME.path });
          const eventEmit = {
            showHome: true,
            showRes: false,
          };
          this.$store.dispatch("changeShowMainComponent", eventEmit);
        }
      }, 300);
    },
    receiveCategoriesSelected(event: string) {
      this.$store.dispatch("selectFacets", event.split(" (")[0]);
      this.$router.push({
        path: ROUTES.SEARCH.path,
        query: DestoreService.paramsRoute(this.search, this.getFacetsSelected),
      });
    },
    deleteCategory(event: string[]) {
      this.$store.dispatch("removeFacetSelected", event);
      const pathRedirect =
        this.getFacetsSelected.length > 0 || this.search
          ? ROUTES.SEARCH.path
          : ROUTES.HOME.path;
      this.$router.push({
        path: pathRedirect,
        query: DestoreService.paramsRoute(this.search, this.getFacetsSelected),
      });
      if (this.getFacetsSelected.length === 0 && !this.search) {
        this.$store.dispatch("changeShowMainComponent", {
          showHome: true,
          showRes: false,
        });
      }
    },
    async updateSearchAndRouter() {
      if (this.$route.query.q || this.$route.query.appCategories) {
        const categoriesQuery = this.$route.query.appCategories as string;
        const searchQuery = this.$route.query.q as string;
        if (searchQuery) {
          this.search = searchQuery;
        }
        if (categoriesQuery) {
          const categoriesArray = categoriesQuery.split(",");
          for (const category of categoriesArray) {
            const includes = await this.$store.dispatch(
              "searchIfFacetIsSelected",
              category
            );
            if (!includes) {
              await this.$store.dispatch("selectFacets", categoriesQuery);
            } else {
              await this.$store.dispatch("changeFacets", categoriesArray);
            }
          }
        }
        const payloadFacets: PayloadFacets = {
          appName: this.search,
          facetsSelected: this.getFacetsSelected,
        };
        await this.$store.dispatch("searchAppsByCategory", payloadFacets);
        await this.$store.dispatch("changeShowMainComponent", {
          showHome: false,
          showRes: true,
        });
      } else {
        this.search = "";
        await this.$store.dispatch("removeTagList");
        await this.$store.dispatch("removeApps");
      }
    },
  },
  watch: {
    "$route.query.q": function () {
      this.updateSearchAndRouter();
    },
    "$route.query.appCategories": function () {
      this.updateSearchAndRouter();
    },
  },
  props: {
    isSearchBarFocused: {
      type: Boolean,
      default: false,
    },
  },
});
